import React from "react";
import { Link } from "react-router-dom";

/**
 * BrandLogo - official Intuiterview brand identity.
 *
 * The user's uploaded PNG lockup contains the "O" monogram + "Intuiterview"
 * wordmark baked into a single image (no tagline). We render it as-is
 * across all product and marketing surfaces for a consistent identity.
 *
 * Variants:
 *   "lockup" - full logo image (icon + wordmark) - default
 *   "icon"   - just the golden "O" monogram
 *
 * Sizing is driven by iconSize (height in px). Width scales automatically
 * to preserve the source aspect ratio.
 */

// Lockup aspect ratio derived from the source PNG (1592 × 353 ≈ 4.51)
const LOCKUP_RATIO = 1592 / 353;

export default function BrandLogo({
  variant = "lockup",
  iconSize = 32,
  className = "",
  as = "link",
  to = "/",
  testid = "brand-logo",
  // Accepted for backward compatibility but no longer changes rendering
  context, // legacy prop
  wordmarkClassName, // legacy prop
}) {
  const isIconOnly = variant === "icon";
  const src = isIconOnly
    ? "/brand/intuiterview-icon.png?v=4"
    : "/brand/intuiterview-lockup.png?v=4";

  const height = iconSize;
  const width = isIconOnly ? iconSize : Math.round(iconSize * LOCKUP_RATIO);

  const content = (
    <img
      src={src}
      alt="Intuiterview"
      width={width}
      height={height}
      style={{ height, width }}
      className={`object-contain select-none ${className}`}
      draggable={false}
      data-testid={testid}
    />
  );

  if (as === "div") return content;
  return (
    <Link to={to} className="inline-flex items-center">
      {content}
    </Link>
  );
}
